<script>
    import { onMount } from "svelte";
    import { Input } from "sveltestrap";
    import store from "../store";
    import { _log } from "../utils/logger";
    export let id;
    let drawStrokeDash = [5, 10, 0, 0, 0, 0, 0, 0];

    onMount(() => {
        return store.subscribe((s) => {
            if (id === "frame") {
                drawStrokeDash = s.drawStrokeDashFrame;
            } else {
                drawStrokeDash = s.drawStrokeDash;
            }
            _log("drawStrokeDash", drawStrokeDash);
        });
    });

    function onInputHandler(e, i) {
        _log("onInputHandler", i);
        drawStrokeDash[i] = +e.target.value;
        if (id === "frame") {
            store.setValue("drawStrokeDash" + "Frame", drawStrokeDash);
        } else {
            store.setValue("drawStrokeDash", drawStrokeDash);
        }
        window.fabricHelper.updateActive("drawStrokeDash");
    }
</script>

<div class="flex fjc">
    {#each drawStrokeDash as item, i}
        <Input
            class="numbersInput"
            on:input={(e) => onInputHandler(e, i)}
            bind:value={drawStrokeDash[i]}
            min={0}
            max={100}
            name={`${item}_${i}`}
            type="number"
        />
    {/each}
</div>
